import { render } from "./CreateArticleModal.vue?vue&type=template&id=784a89f6"
import script from "./CreateArticleModal.vue?vue&type=script&lang=js"
export * from "./CreateArticleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__